<template>
    <div class="auto">
      <div class="w75">
        <div class="Location002308" @click="breadcrumbJump">
          <div>
            {{selectMenu.name}}
          </div>
          <div>
              您所在位置:
              <a href="https://www.yzhospital.cn/index.aspx">首页</a>
              <span @click="breadcrumbJump">{{selectMenu.name}}</span>
          </div>
        </div>
      </div> 

    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        selectMenu:{
          name:''
        },
      };
    },
    watch: {
      $route(val) {
        //val即是this.$route
        //根据路由控制其他参数做不同处理
        this.selectMenu = this.$route 
      },
    },
    mounted(){
      this.selectMenu.name = this.$route.name
    },
   
    methods: {
      
      breadcrumbJump(){
        // console.log(this.selectMenu)
        // let e = this.selectMenu.father.children[0]
        // if(e.url){
        //   window.location = 'https://www.yzhospital.cn'+ e.url
        // }else{
        //   this.$router.push(e.path)
        //   // this.selectedKeys = e.key
        // }
      }
    },
  };
  </script>
  <style scoped lang="less">
    .auto{
      max-width: 1280px;
      margin: 0 auto;
      padding-top: 3%;
      padding-bottom: 4%;
      .w75 {
        width: 100%;
        padding-bottom: 4%;
      }
      
    }
   
    .Location002308{
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: #e5e5e5 1px solid;
      >div:nth-child(1){
      
        font-weight: bold;
        font-size: 24px;
        color: @main-color;
      }
      >div:nth-child(2){
        font-style: normal;
        color: #999;
        background: url(https://www.yzhospital.cn/cn//images/Location002308-icon.png) no-repeat left center;
        padding-left: 15px;
        >a{
          position: relative;
          padding-right: 15px;
          margin-right: 10px;
          color: #999;
        }
        >a:hover{
          color: @main-color;
          cursor: pointer;
        }
        
       
        >a::before{
            position: absolute;
            content: '';
            right: 0;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
            border-left: 5px solid #a1a1a1;
            top: 50%;
            margin-top: -4px;
        }
        >span:nth-child(2){
          color:@main-color;
        }
      }
    }
    @media (max-width: 1280px){
      .auto{
        width: 100%;
        padding: 3% 2% 2%;
       
      }
    }
    @media (max-width: 1024px){
      .auto{
        .w75 {
            width: auto;
            padding-bottom: 2%;
        }
      }

    }
    @media (max-width: 640px){
      .Location002308>div:nth-child(2){
          display: none;
      }
    } 

  </style>
  